<template>
  <div>
    <template v-if="!getLoadingBoolean">
      <MobialisProgressBar
        v-if="$route.meta.progressBar"
        class="custom-mb"
        :numberOfSteps="progressBarData.numberOfSteps"
        :navInfo="progressBarData.navInfo"
      >
        {{ $t('message.trade.vehicleValueWrapperHeader') }}
      </MobialisProgressBar>
      <MobialisHorizontalRuleHeader v-else-if="$route.meta.wrapperHeader" data-test="wrapperHeader" class="custom-mb">
        {{ $t('message.trade.vehicleValueWrapperHeader') }}
      </MobialisHorizontalRuleHeader>
    </template>
    <CurrentVehicleSelection v-if="showCurrentVehicleSelection"></CurrentVehicleSelection>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CurrentVehicleSelection from '@/components/trade-in/CurrentVehicleSelection.vue';
import { AVRProducts, VehicleCategoryTypes } from '@/utils/enums';
import TradeInSource from '@/utils/enums/tradeInSource';

export default {
  name: 'TradeWrapper',
  components: {
    CurrentVehicleSelection,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getLoadingBoolean', 'getCurrentProduct']),
    ...mapGetters({
      mobileVerificationEnabled: 'business/mobileVerificationEnabled',
      tradeAcquireAdditionalVehicleDetails: 'business/tradeAcquireAdditionalVehicleDetails',
    }),
    progressBarData() {
      if (this.$route.meta.progressBar) {
        const numberOfSteps = this.getNumberOfTotalSteps();
        const currentStep = this.getCurrentStep(numberOfSteps);
        return {
          numberOfSteps,
          navInfo: {
            from: currentStep - 1,
            to: currentStep,
          },
        };
      }
      return {};
    },
    showCurrentVehicleSelection() {
      if (!this.getLoadingBoolean) {
        if (this.$route.meta.displayVehicleString) {
          return true;
        }
      }
      return false;
    },
    tradeInSourceIsCarfax() {
      return this.$store.getters['business/getTradeInSource'] === TradeInSource.CARFAX;
    },
  },
  methods: {
    getNumberOfTotalSteps() {
      // US trade
      let numberOfSteps = 7;
      if (this.isAVRDesktop) {
        numberOfSteps = 2;
      }
      // Canada trade/acquire, same for mobile and desktop
      if (this.tradeInSourceIsCarfax) {
        numberOfSteps = 3;
      }
      // S&R trade
      if (
        this.$store.state.business.info.integrationSettings.tradeSREnabled &&
        this.getCurrentProduct === AVRProducts.TRADE
      ) {
        numberOfSteps = 3; // 3 total pages for trade S&R
        if (
          this.$store.state.business.info.integrationSettings.tradeAutosEnabled &&
          this.$store.state.trade.vehicle.vehicleCategoryType === VehicleCategoryTypes.AUTO
        ) {
          if (!this.tradeInSourceIsCarfax) {
            numberOfSteps -= 1; // one less page if both are enabled and you select "Auto"
          }
        }
      }
      if (this.mobileVerificationEnabled) {
        numberOfSteps += 2; // two extra pages for mobile verification
      }
      if (this.tradeAcquireAdditionalVehicleDetails) {
        numberOfSteps += 1; // one extra page for additional vehicle details
      }
      return numberOfSteps;
    },
    getCurrentStep(numberOfSteps) {
      // ---- Count backwards from the end of the flow to determine the current step for the last few pages ----
      let { currentStep } = this.$route.meta.progressBar;
      const { currentStepName } = this.$route.meta.progressBar;
      // personal-info-form should be before mobile verification and before additional vehicle details
      if (currentStepName === 'personal-info-form') {
        if (this.mobileVerificationEnabled) {
          if (this.tradeAcquireAdditionalVehicleDetails) {
            currentStep = numberOfSteps - 4;
          } else {
            currentStep = numberOfSteps - 3;
          }
        } else if (this.tradeAcquireAdditionalVehicleDetails) {
          currentStep = numberOfSteps - 2;
        } else {
          currentStep = numberOfSteps - 1;
        }
      }
      // additional-vehicle-details should be at the end of the flow, but before mobile verification if it is enabled
      if (currentStepName === 'additional-vehicle-details') {
        if (this.mobileVerificationEnabled) {
          currentStep = numberOfSteps - 3;
        } else {
          currentStep = numberOfSteps - 1;
        }
      }
      // mobile verification pages should always be at the end of the flow
      if (currentStepName === 'mobile-verification') {
        currentStep = numberOfSteps - 2;
      }
      if (currentStepName === 'verification-code') {
        currentStep = numberOfSteps - 1;
      }
      return currentStep;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-mb {
  margin-bottom: 24px;
}
</style>
